// src/App.js
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { OutreachProvider }      from './context/OutreachContext'
import { ScheduleProvider }      from './context/ScheduleContext'

import HomePage     from './pages/HomePage'
import SchedulePage from './pages/SchedulePage'
import Footer       from './components/Footer'

// this inner component can call useAuth (must live beneath AuthProvider)
function AppContent() {
  const { user } = useAuth()

  return (
    <>
      <Routes>
        <Route path="/"        element={<HomePage />} />
        <Route path="/schedule" element={<SchedulePage />} />
      </Routes>

      {/* only show the footer if someone is logged in */}
      {user && <Footer />}
    </>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <OutreachProvider>
        <ScheduleProvider>
          <AppContent />
        </ScheduleProvider>
      </OutreachProvider>
    </AuthProvider>
  )
}
